// src/data/menuItems.js

export const menuItems = [
  {
    title: "x InZoi",
    link: "https://www.epicevils.com/collab",
  },
  {
    title: "Services",
    link: "#",
    submenu: [
      { title: "TCGSE", link: "https://www.tcgse.com" },
      { title: "DeckMaker", link: "https://deckmaker.tcgse.com" },
      { title: "Leagues", link: "https://play.epicevils.com" },
    ],
  },
  {
    title: "Roster",
    link: "https://www.epicevils.com/roster",
  },
  {
    title: "Club",
    link: "#",
    submenu: [
      { title: "News", link: "https://www.tcgse.com/articles" },
      { title: "Team", link: "https://www.epicevils.com/team" },
      { title: "Clothes", link: "https://www.epicevils.com/clothes" },
      { title: "Standings", link: "https://www.epicevils.com/standings" },
      { title: "Contact", link: "https://www.epicevils.com/contact" },
    ],
  }
];